import { List } from '@factorialco/deprecated-design-system'
import { ProjectManagementProjectRoleRoleEnum } from 'generated/resources/graphql'

import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'

import CreateProjectRolePopover from './CreateProjectRolePopover'
import CreateProjectRoleRow from './CreateProjectRoleRow'

export interface projectRoleInterface {
  role: ProjectManagementProjectRoleRoleEnum
  employee: EmployeeForSelectFragmentNoAccess
}

export interface CreateProjectRolesSelectorProps {
  projectRoles: projectRoleInterface[]
  onUpdateRow: (employeeId: number, role: ProjectManagementProjectRoleRoleEnum) => void
  onDeleteRow: (employeeId: number) => void
  isProjectOwner?: boolean
  resetEmployeeSelection: () => void
  excludeEmployeeIds: number[]
  employeeSelection: EmployeeSelectorV2MultiSelectState
  onSelectEmployees: (selection: EmployeeSelectorV2MultiSelectState) => void
}

export const CreateProjectRolesSelector = ({
  projectRoles,
  onUpdateRow,
  onDeleteRow,
  isProjectOwner = true,
  resetEmployeeSelection,
  excludeEmployeeIds,
  employeeSelection,
  onSelectEmployees,
}: CreateProjectRolesSelectorProps) => {
  const { employee } = useCurrentSession()
  const currentEmployeeId = employee?.id

  const isThatYou = (employeeId: number) => {
    return employeeId === currentEmployeeId
  }

  const onSubmit = () => {
    if (employeeSelection.type === 'manual') {
      const newSelectedIds = employeeSelection.ids.filter((id) => {
        return !projectRoles.map((pr) => pr.employee.id).includes(id)
      })

      newSelectedIds.forEach((id) => {
        onUpdateRow(id, 'editor')
      })
    }
  }

  const handleUpdateRow = (
    employeeData: EmployeeForSelectFragmentNoAccess,
    role: ProjectManagementProjectRoleRoleEnum
  ) => {
    onUpdateRow(employeeData.id, role)
  }

  const handleDeleteRow = (employeeData: EmployeeForSelectFragmentNoAccess) => {
    onDeleteRow(employeeData.id)
  }

  const selectedCount = employeeSelection.type === 'manual' ? employeeSelection.ids.length : 0

  return (
    <>
      {projectRoles.length !== 0 && (
        <List>
          {projectRoles.map((role, index) => (
            <CreateProjectRoleRow
              key={index}
              editable={!isThatYou(role.employee.id) && isProjectOwner}
              deletable={!isThatYou(role.employee.id)}
              role={role.role}
              employee={role.employee}
              employeeName={
                role.employee.fullName +
                (isThatYou(role.employee.id) ? ` (${i18n.t('common.you')})` : '')
              }
              onUpdateRow={handleUpdateRow}
              onDeleteRow={handleDeleteRow}
            />
          ))}
        </List>
      )}
      <CreateProjectRolePopover
        onSubmit={onSubmit}
        resetEmployeeSelection={resetEmployeeSelection}
        disabledSubmitButton={selectedCount === 0}
        excludeEmployeeIds={excludeEmployeeIds}
        employeeSelection={employeeSelection}
        onSelectEmployees={onSelectEmployees}
      />
    </>
  )
}
